const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/report/summary',
    authenticatedEntryPathAdminExpert: '/app/report/summary',
    authenticatedEntryPathStandard: '/app/report/summary',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig